export enum RequestStatusEnums {
  LOADING = "loading",
  PENDING = "pending",
  SUCCESS = "success",
  FAIL = "fail",
}

export enum RelationshipStatusEnums {
  ACCEPTED = "ACCEPTED",
  REQUEST = "REQUEST",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export enum AppPathsEnum {
  LOGIN = "/login",
  HOME = "/home",
}

export enum DisplayMode {
  GRID = "grid",
  LIST = "list",
}

export const PAGE_DEFAULT = 1;

export const TOTAL_PAGE_DEFAULT = 1;

export const PAGE_SIZE_DEFAULT = 20;

/** Kích thước trang cho các màn hình dạng lưới nhóm (3 cột). */
export const GRID_PAGE_SIZE = 18;

/** Kích thước trang khi cần lấy toàn bộ bản ghi trong 1 lần gọi API. */
export const GET_ALL_PAGE_SIZE = 9999;

/** Thời gian chờ tối đa cho mỗi request (mili-giây). */
export const API_TIMEOUT_MS = 10 * 1000;

/** Thời gian đếm ngược (giây) cho các luồng OTP/xác thực. */
export const COUNT_DOWN = 60;

export const QR_CODE_EXPIRE_BY_SECONDS = 30;

export const MAX_IMAGE_SIZE = 2000 * 1024;

/** Đuôi ảnh backend chấp nhận (backend suy định dạng từ tên file). */
export const ACCEPTED_IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "webp"];

/** MIME tương ứng, dùng cho thuộc tính `accept` của input file. */
export const ACCEPTED_IMAGE_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];

/** Giá trị dùng trực tiếp cho `accept` của các input chọn ảnh. */
export const ACCEPTED_IMAGE_ACCEPT_ATTR = ACCEPTED_IMAGE_MIME_TYPES.join(", ");
